import { includes, some } from 'lodash'
export const validateRole = (roles, userroles) => {
  if (roles) {
    const findFenix = (roles, userRoles) => {
      const findUserRoles = userRoles?.find((rol) =>
        rol?.toUpperCase()?.startsWith('FENIX_'),
      )
      const findRoles = roles?.find((rol) =>
        rol?.toUpperCase()?.startsWith('FENIX_'),
      )
      return findUserRoles && findRoles
    }
    const result =
      some(roles, (ro) => includes(userroles, ro)) ||
      findFenix(roles, userroles)
    return result
  }

  return true
}
